export const useDeepLinks = () => {
  const deepLinks = [
    "ble.ir/feed-page",
    "ble.ir/market/search",
    "ble.ir/banking-vitrine",
  ];

  const isDeepLink = (link: string) => deepLinks.includes(link);

  return { isDeepLink };
};
